/* src/app/pages/dashboard-finance/dashboard-finance.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
  gap: 10px;
}
:host ::ng-deep bfm-dashboard-summary {
}
:host ::ng-deep bfm-dashboard-summary .default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
:host ::ng-deep bfm-dashboard-summary .default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
:host ::ng-deep bfm-dashboard-summary .default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host ::ng-deep bfm-dashboard-summary .default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep bfm-dashboard-summary .default-flex-column {
  display: flex;
  flex-flow: column;
}
:host ::ng-deep bfm-dashboard-summary .default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
:host ::ng-deep bfm-dashboard-summary .rounded-circle {
  border-radius: 50%;
}
:host ::ng-deep bfm-dashboard-summary h1,
:host ::ng-deep bfm-dashboard-summary h2,
:host ::ng-deep bfm-dashboard-summary h3,
:host ::ng-deep bfm-dashboard-summary h4,
:host ::ng-deep bfm-dashboard-summary h5,
:host ::ng-deep bfm-dashboard-summary h6,
:host ::ng-deep bfm-dashboard-summary label,
:host ::ng-deep bfm-dashboard-summary p,
:host ::ng-deep bfm-dashboard-summary b,
:host ::ng-deep bfm-dashboard-summary small,
:host ::ng-deep bfm-dashboard-summary span,
:host ::ng-deep bfm-dashboard-summary strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
:host ::ng-deep bfm-dashboard-summary h1.cds-required::after,
:host ::ng-deep bfm-dashboard-summary h2.cds-required::after,
:host ::ng-deep bfm-dashboard-summary h3.cds-required::after,
:host ::ng-deep bfm-dashboard-summary h4.cds-required::after,
:host ::ng-deep bfm-dashboard-summary h5.cds-required::after,
:host ::ng-deep bfm-dashboard-summary h6.cds-required::after,
:host ::ng-deep bfm-dashboard-summary label.cds-required::after,
:host ::ng-deep bfm-dashboard-summary p.cds-required::after,
:host ::ng-deep bfm-dashboard-summary b.cds-required::after,
:host ::ng-deep bfm-dashboard-summary small.cds-required::after,
:host ::ng-deep bfm-dashboard-summary span.cds-required::after,
:host ::ng-deep bfm-dashboard-summary strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
:host ::ng-deep bfm-dashboard-summary h1[class^=c-],
:host ::ng-deep bfm-dashboard-summary h2[class^=c-],
:host ::ng-deep bfm-dashboard-summary h3[class^=c-],
:host ::ng-deep bfm-dashboard-summary h4[class^=c-],
:host ::ng-deep bfm-dashboard-summary h5[class^=c-],
:host ::ng-deep bfm-dashboard-summary h6[class^=c-],
:host ::ng-deep bfm-dashboard-summary label[class^=c-],
:host ::ng-deep bfm-dashboard-summary p[class^=c-],
:host ::ng-deep bfm-dashboard-summary b[class^=c-],
:host ::ng-deep bfm-dashboard-summary small[class^=c-],
:host ::ng-deep bfm-dashboard-summary span[class^=c-],
:host ::ng-deep bfm-dashboard-summary strong[class^=c-] {
  color: var(--color);
}
:host ::ng-deep bfm-dashboard-summary b,
:host ::ng-deep bfm-dashboard-summary strong,
:host ::ng-deep bfm-dashboard-summary span {
  font-family: var(--cds-font-family);
}
:host ::ng-deep bfm-dashboard-summary h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary p.bold {
  font-weight: bold;
}
:host ::ng-deep bfm-dashboard-summary label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host ::ng-deep bfm-dashboard-summary h2 {
  font-weight: bold;
  font-size: 28px;
}
:host ::ng-deep bfm-dashboard-summary section.span > span.default-flex-between {
  display: none;
}
:host ::ng-deep bfm-dashboard-summary section {
  gap: 16px;
}
:host ::ng-deep bfm-dashboard-summary .cds-card h4:not(.percentage-text) {
  font-weight: 600;
}
:host ::ng-deep bfm-dashboard-summary .cds-card .cds-icon-filled-question {
  color: var(--cds-icon-strong);
}
:host ::ng-deep bfm-dashboard-summary .percentage-text {
  font-size: 16px;
  font-weight: 400;
  top: unset;
  right: unset;
  transform: unset;
}
:host ::ng-deep bfm-dashboard-summary .cds-card.s-elevated-9 {
  box-shadow: unset !important;
}
:host ::ng-deep bfm-dashboard-summary .cds-card.chart bfm-dashboard-line-graph {
  padding-right: 8px;
}
:host ::ng-deep bfm-dashboard-summary .grouped-item.predicted .text-column::before {
  background-color: var(--cds-text-medium) !important;
}
:host ::ng-deep bfm-dashboard-summary ngx-charts-line-chart {
  position: relative !important;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-donut-graph {
  --donut-chart-stroke-width: 25;
  --donut-chart-stroke-linejoin: miter;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-donut-graph.revenue [ngx-charts-pie-series] > g:first-child .arc {
  stroke: #A0D2FC !important;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-donut-graph.expense [ngx-charts-pie-series] > g:first-child .arc {
  stroke: #F0AFAF !important;
}
:host ::ng-deep bfm-dashboard-summary section,
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-bar-graph {
  max-height: unset;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(1) {
  grid-column-start: 1;
  grid-row: 1/span 2;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(2) {
  grid-column-start: 2;
  grid-row: 1/span 2;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(3) {
  grid-column-start: 3;
  grid-row-start: 3;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(4) {
  grid-column-start: 4;
  grid-row-start: 3;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(5) {
  grid-column: 3/span 2;
  grid-row: 4/span 2;
  max-height: 415px;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(6) {
  grid-column-start: 2;
  grid-row-start: 3;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(7) {
  grid-column-start: 1;
  grid-row-start: 3;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(8) {
  grid-column: 1/span 2;
  grid-row: 4/span 2;
}
:host ::ng-deep bfm-dashboard-summary bfm-dashboard-finance section:nth-child(9) {
  grid-column: 3/span 2;
  grid-row: 1/span 2;
}
:host ::ng-deep bfm-dashboard-summary .session-custom {
  background-color: var(--cds-background-elevated);
}
:host ::ng-deep bfm-dashboard-summary .session-custom .info-card {
  display: grid;
  gap: 18px;
}
:host ::ng-deep bfm-dashboard-summary .session-custom .info-card h4 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: 600;
  color: var(--cds-primary-500);
  line-height: 1;
  padding: 6px 0;
  font-weight: bold;
}
:host ::ng-deep bfm-dashboard-summary .session-custom .info-card .info-text {
  font-size: 16px;
  line-height: 1.5;
  color: var(--cds-text-strong);
}
/*# sourceMappingURL=dashboard-finance.component.css.map */
